import { useState } from 'react'
import { fetcher, AdminPurchaseRewardExclusionsEndpoints, IUsePurchaseRewardExclusions } from '@olagg/api-hooks'
import { PurchaseRewardExclusion } from '@olagg/db-types'

interface PurchaseRewardExclusionsResponse {
  purchaseRewardExclusions: PurchaseRewardExclusion[]
  meta: {
    count: number
  }
}

const usePurchaseRewardExclusions = () => {
  const [loading, setLoading] = useState(false)

  const getExclusions = async (filter: IUsePurchaseRewardExclusions): Promise<PurchaseRewardExclusionsResponse> => {
    try {
      setLoading(true)
      const endpoint = AdminPurchaseRewardExclusionsEndpoints.all(filter)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error fetching purchase reward exclusions:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const createExclusion = async (data: { product_uid: string; reason?: string }): Promise<PurchaseRewardExclusion> => {
    try {
      setLoading(true)
      const endpoint = AdminPurchaseRewardExclusionsEndpoints.create(data)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error creating purchase reward exclusion:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const deleteExclusion = async (id: number): Promise<void> => {
    try {
      setLoading(true)
      const endpoint = AdminPurchaseRewardExclusionsEndpoints.delete(id)
      await fetcher(endpoint)
    } catch (error) {
      console.error('Error deleting purchase reward exclusion:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    getExclusions,
    createExclusion,
    deleteExclusion
  }
}

export default usePurchaseRewardExclusions
